import React from "react";

import { LockedItemPopoverContent } from "../_locked-item-popover";
import { LockedChart, type LockedChartProps } from "../react/chart/chart-states/LockedChart";

export interface LockedMetricProps extends Pick<LockedChartProps, "size"> {
	title: string;
}

export const LockedMetric: React.FC<LockedMetricProps> = ({ title, size }) => (
	<LockedChart
		popoverContent={
			<LockedItemPopoverContent
				actionType="metrics"
				capture={{
					location: "signal",
					name: title,
					size,
				}}
				className="w-[340px] p-4"
				content="Being able to inspect all the RED signals allows you to quickly identify issues."
				title={title}
			/>
		}
		size={size}
	/>
);
